<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$auth.policies['view-student-mark']">
        <StudentProfileMarks :student="student" />
      </v-col>
      <v-col cols="12" md="8" v-if="isShowExtraCurriculum">
        <StudentExtraClass :student="student" />
      </v-col>
      <v-col cols="12" md="6" v-if="$auth.policies['view-attendance-item'] && $auth.policies['view-attendance-list']">
        <v-card outlined>
          <v-card-title>
            <v-icon color="primary">mdi-calendar-account</v-icon>
            <span class="ml-2 text-subtitle-2">Chuyên cần</span>
            <v-spacer></v-spacer>
            <v-btn class="text-none" color="primary" text>Xem chi tiết</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="text-center" cols="4">
                <span class="col-1">{{ totalAbsent }}</span>
                <br />
                <span class="text-subtitle">Số ngày nghỉ</span>
              </v-col>
              <v-divider class="my-2" vertical></v-divider>
              <v-col class="text-center" cols="4">
                <span class="col-2">{{ invalidAbsent }}</span> <br />
                <span class="text-subtitle">Số ngày nghỉ không phép</span>
              </v-col>
              <v-divider class="my-2" vertical></v-divider>
              <v-col class="text-center" cols="4">
                <span class="col-2">{{ validAbsent }}</span> <br />
                <span class="text-subtitle">Số ngày nghỉ có phép</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="$auth.policies['view-violation-list']">
        <v-card outlined>
          <v-card-title>
            <v-icon color="primary">mdi-star</v-icon>
            <span class="ml-2 text-subtitle-2">Khen thưởng kỷ luật</span>
            <v-spacer></v-spacer>
            <v-btn class="text-none" color="primary" text :to="`/complimented/?student=${student.id}`"
              >Xem chi tiết</v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-row class="py-6">
              <v-col class="text-center" cols="4">
                <span class="col-1">{{ commendCount }}</span>
                <br />
                <span class="text-subtitle">Khen thưởng</span>
              </v-col>
              <v-divider class="my-2" vertical></v-divider>
              <v-col class="text-center" cols="4">
                <span class="col-2">{{ violationCount }}</span> <br />
                <span class="text-subtitle">Kỷ luật</span>
              </v-col>
            </v-row>
            <ViolationDataTable :hideFooter="true" :headers="violationHeader" ref="violationDataTable" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <StudentProfileNotifications :student="student" />
      </v-col>
      <v-col cols="12">
        <StudentOnlineStudy :student="student" class="pa-4" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AttendanceStudentDataTable from '@/views/attendance/components/AttendanceStudentDataTable'
import ViolationDataTable from '@/views/violation/components/ViolationDataTable'
import StudentProfileMarks from './StudentProfileMarks.vue'
import StudentExtraClass from './StudentExtraClass.vue'
import StudentProfileNotifications from './StudentProfileNotifications.vue'
import StudentOnlineStudy from './StudentOnlineStudy.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import { Diligence } from '@/plugins/api'

export default {
  data() {
    return {
      tab: null,
      commendCount: 0,
      violationCount: 0,
      totalAbsent: 0,
      invalidAbsent: 0,
      validAbsent: 0,
      violationHeader: [
        { text: 'Ngày', value: 'date' },
        { text: 'Mục', value: 'type' },
        { text: 'Nội dung', value: 'description' },
      ],
      attendanceHeaders: [
        { text: 'Ngày', value: 'date' },
        { text: 'Giờ đến / Giờ về', value: 'time' },
        { text: 'Trạng thái', value: 'status', align: 'center' },
      ],
      isShowExtraCurriculum: false,
    }
  },
  components: {
    StudentProfileMarks,
    StudentExtraClass,
    ViolationDataTable,
    AttendanceStudentDataTable,
    StudentProfileNotifications,
    StudentOnlineStudy,
  },
  props: {
    student: Object,
  },
  computed: {
    ...mapState('violation', ['violations']),
    ...mapGetters('attendance', ['attendances']),
    ...mapState('app', ['currentSemester']),
  },
  async created() {
    if (this.student.classes.length > 1) {
      this.isShowExtraCurriculum = true
    } else {
      this.isShowExtraCurriculum = false
    }
    this.commendCount = await this.count({
      student: this.student.id,
      type: 'commendation',
    })
    this.violationCount = await this.count({
      student: this.student.id,
      type: 'violation',
    })
    this.totalAbsent = await Diligence.count({
      student: this.student.id,
      present: 'false',
    })
    this.invalidAbsent = await Diligence.count({
      student: this.student.id,
      status: 'invalidAbsent',
    })
    this.validAbsent = await Diligence.count({
      student: this.student.id,
      status: 'validAbsent',
    })
  },
  mounted() {
    if (this.$refs.violationDataTable) {
      this.$refs.violationDataTable.refresh({
        student: this.student.id,
        _limit: 10,
      })
    }
  },
  methods: {
    ...mapActions('violation', ['count']),
    ...mapActions('attendance', ['fetchAttendances']),
  },
}
</script>

<style scoped>
.col-1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #46be8a;
}
.col-2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #ffab40;
}
</style>
